import { FC } from 'react';

import Badge, { BADGE_TYPE } from '@components/Badge';

interface TranslationStatusBadgeProps {
  status: string | null;
}
const TransaltionStatusBadge: FC<TranslationStatusBadgeProps> = ({ status }) => {
  if (!status) return null;
  let color;
  switch (status) {
    case 'in progress':
      color = BADGE_TYPE.LIGHT_GREEN;
      break;
    case 'queued':
      color = BADGE_TYPE.DEEP_BLUE;
      break;
    default:
      color = BADGE_TYPE.GREY;
  }

  return <Badge type={color}>{status}</Badge>;
};

export default TransaltionStatusBadge;
